import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import { QuizTextLink } from "~/components/features/quiz";

export const faqList = [
    {
        id: 1,
        question: "How is your formulation different than what my doctor can give me?",
        answer: "Our formulation is exclusive to Inner Balance, so it cannot be prescribed by your physician. In addition, our experts are trained and knowledgeable about making adjustments if you experience any side effects when starting.",
    },
    {
        id: 2,
        question: "Is it covered by insurance?",
        answer: "Our approach to estradiol/progesterone replacement therapy, which strives for optimal levels, is not covered by insurance. The problem with insurance is that, once your levels reach ‘normal’, your insurance carrier deems you to be cured. In addition, they only cover treatments that achieve arbitrary ‘normal’ lab levels. The thing is, most women still experience negative symptoms with ‘normal’ levels. This is the main reason women come to Inner Balance: to achieve optimal levels of all three hormones and feel their absolute best.",
    },
    {
        id: 3,
        question: "Is it personalized to me?",
        answer: "Our treatment is a custom-made formulation that can be adjusted based on your symptoms and how your body adjusts. It doesn't get any more personalized than that. You have the option of starting lower and increasing (or not) at your own pace. This is different than other cookie-cutter and one-size-fits-all products that can't be adjusted, or personalized to your specific needs.",
    },
    {
        id: 4,
        question: "Do I need to keep taking this forever?",
        answer: "Hormones give you the potential to continuously feel better than the day before for the rest of your life. If you decide at any point to stop, then you will just go back to how you were feeling before you started. There is no harm in starting and stopping if you find it isn’t a good fit for you.",
    },
    {
        id: 5,
        question: "How do you know what dose to give me?",
        answer: "Our formulation is customizable, which means that you can use less or more based on your specific needs. Our starting dose is sufficient to eliminate the vast majority of symptoms and you will start to notice a difference within days.  Most women still have symptoms on other formulations like patches, pills and topical creams.",
    },
    {
        id: 6,
        question: "Do I need a lab test to confirm?",
        answer: "We do not require a blood test to get started. We also don't force you into a lab range that may not be right for you.  Instead, we ensure that all your symptoms resolve and you have no lasting side effects",
    },
    {
        id: 7,
        question: "Is it safe?",
        answer: "YES! Estradiol and progesterone are FDA approved to treat any symptom related to low ovarian function.  Also, hormones have been found to be protective against many diseases such as dementia, Alzheimers', heart disease, osteoporosis, diabetes, obesity, urinary tract infections and incontinence. We have also known for nearly 10 years that estradiol was never shown to increase risk for breast cancer.",
    },
];

export const faqReferralsList = [
    {
        id: 1,
        question: "Who can refer friends?",
        answer: "Referrals are available exclusively to current Inner Balance subscribers. Just sign in to your account to access your Referral Dashboard—everything you need to get started is right there.",
    },
    {
        id: 2,
        question: "Is there a referral limit?",
        answer: "Referral rewards are limited to 3 successful claims. After your 3rd claimed referral, your link will still work and your friends will still receive their $99 discount, but you won’t receive additional rewards beyond the cap. Referral links are intended for personal use only. Mass sharing (e.g., on Reddit or coupon sites) may result in referral rewards being disabled. Inner Balance reserves the right to modify or end the referral program at any time. One friend per link — each referral link can only be used once.",
    },
    {
        id: 3,
        question: "How do I get my referral link?",
        answer: "Just sign in to your account and go to your Referral Dashboard. From there, you can copy your personal referral link and share it via text, email, social media, or however you prefer.",
    },
    {
        id: 4,
        question: "What do my friends need to do?",
        answer: "Your friends simply need to follow your referral link to the Inner Balance website, complete the quiz, and check out. Their $99 discount will be automatically applied at checkout—no promo code required.",
    },
    {
        id: 5,
        question: "How can I track my referrals?",
        answer: "You can see all your claimed referrals in your Referral Dashboard. You’ll be able to view who used your link and when your rewards are earned.",
    },
    {
        id: 6,
        question: "Can I use the same link for more than one friend?",
        answer: "No. Each referral link is unique and works only once. As soon as one friend uses it, it's spent — generate a fresh link from your Referral Dashboard for the next person.",
    },
];

export const faqWebinarList = [
    {
        id: 1,
        question: "Do I need to have my camera or microphone on?",
        answer: "No. The session is completely anonymous — you can join without turning on your camera or microphone. You’re welcome to simply listen in. If you’d like your name to appear differently during the session, you can update it when you join.",
    },
    {
        id: 2,
        question: "Will I be able to ask questions during the session?",
        answer: "Yes. When you register, you can submit your questions in advance. Dr. Sarah will answer as many as she can during the live Q&A. Or, if you forgot to submit questions ahead of time, be sure to drop them in the chat once you enter the Office Hours. Questions added to our website chat will not be addressed in the session.",
    },
    {
        id: 3,
        question: "When can I register?",
        answer: "You can register any time before the session begins. After that, registration will close.",
    },
    {
        id: 4,
        question: "What if I can’t make it live?",
        answer: "We highly recommend attending live if possible — it’s the best way to get your questions answered in real time. At this time, we are not sending out session recordings.",
    },
    {
        id: 5,
        question: "How long is the session?",
        answer: "The session is approximately 60–90 minutes, including time for live Q&A.",
    },
    {
        id: 6,
        question: "Is this session just for people with specific diagnoses?",
        answer: "No, the live session is designed to help new patients understand what to expect, regardless of whether they’re managing PMOS/PCOS, Endometriosis, Perimenopause or general hormone changes. It’s designed to help all new patients understand what to expect.",
    },
    {
        id: 7,
        question: "Can I invite a friend to the session?",
        answer: <>Office Hours are exclusively for Inner Balance patients. If you know someone who could benefit from Oestra<sup>®</sup>, feel free to use your Refer a Friend link — they’ll receive $99 off, and you’ll earn a reward when they join.</>,
    },
    {
        id: 8,
        question: "Do I need to attend every week?",
        answer: "No — it is designed as a one-time session that repeats weekly. Each session covers  key topics about Oestra, along with answers to the most common questions. You only need to attend once to get the full experience, but you’re always welcome to join again if you’d like a refresher or want to hear the Q&A.",
    },
    {
        id: 9,
        question: "Can I join more than once?",
        answer: "Yes, you can attend multiple sessions if you’d like! However, once you’ve attended, you won’t receive additional email invitations. If you’d like to join another session, simply register again using the registration form above — you’re always welcome to rejoin.",
    },
];

export const faqPreWebinarList = [
    {
        id: 1,
        question: "Do I need to have my camera or microphone on?",
        answer: "No. The session is completely anonymous — you can join without turning on your camera or microphone. You’re welcome to simply listen in. If you’d like your name to appear differently during the session, you can update it when you join.",
    },
    {
        id: 2,
        question: "Will I be able to ask questions during the session?",
        answer: "Yes. When you register, you can submit your questions in advance. Dr. Sarah will answer as many as she can during the live Q&A. Or, if you forgot to submit questions ahead of time, be sure to drop them in the chat once you enter the Office Hours. Questions added to our website chat will not be addressed in the session.",
    },
    {
        id: 3,
        question: "When can I register?",
        answer: "You can register any time before the session begins. After that, registration will close.",
    },
    {
        id: 4,
        question: "What if I can’t make it live?",
        answer: "We highly recommend attending live if possible — it’s the best way to get your questions answered in real time. At this time, we are not sending out session recordings.",
    },
    {
        id: 5,
        question: "How long is the session?",
        answer: "The session is approximately 60–90 minutes, including time for live Q&A.",
    },
    {
        id: 6,
        question: "Is this session just for people with specific diagnoses?",
        answer: <>No. This session is for any woman curious about Oestra<sup>®</sup>. We’ll discuss common hormone imbalance symptoms and causes, how to get started, what ongoing support looks like, and what to expect on your Oestra<sup>®</sup> journey. It’s open to anyone who wants to better understand their hormones and how Inner Balance can help.</>,
    },
    {
        id: 7,
        question: "How can my friend join a session?",
        answer: (
            <>
                If your friend is curious about Oestra<sup>®</sup>, they can start by
                completing the <QuizTextLink href={QUIZ_ROUTES.HORMONE_IMBALANCE}>Hormone Quiz</QuizTextLink> to get
                a personalized overview of their symptoms and how Oestra<sup>®</sup> can
                help. You can also share this registration link with them so
                they can sign up directly for a webinar session whenever they’re
                ready.
            </>
        ),
    },
];

export const faqPostWebinarList = [
    {
        id: 1,
        question: "Will a recording of the session be available?",
        answer: "No, recordings of Office Hours are not available. We encourage you to join live so you can get the most out of the experience.",
    },
    {
        id: 2,
        question: "Can I submit questions ahead of future Office Hours?",
        answer: "Yes! When registering, you’ll have the option to submit questions in advance. If you forget or think of more during the session, you’ll also be able to submit them live.",
    },
    {
        id: 3,
        question: "When is the next Office Hours session?",
        answer: "Stay tuned! Upcoming sessions will be listed in the Account section of your Inner Balance profile.",
    },
    {
        id: 4,
        question: "Can I invite a friend to join Office Hours?",
        answer: "Office Hours are exclusive to Inner Balance patients and require login to access.",
    },
];

export const faqPqpList = [
    {
        id: 1,
        question: "How do I get started?",
        answer: "The first thing to do is to take our health quiz, where we will make sure you are a candidate for Oestra. From there, you’ll checkout. Once our team of experts confirm you’re good to go, we’ll send your prescription to our pharmacy, and they will ship directly to you.",
    },
    {
        id: 2,
        question: "Do I need lab work to start?",
        answer: "No. Lab tests fluctuate and don't tell the whole story. If you’re experiencing symptoms, that’s the signal. We focus on how you feel—not just what your labs say.",
    },
    {
        id: 3,
        question: "Do I need a prescription for Oestra®?",
        answer: <>Yes. After you complete the health quiz, a board-certified physician reviews your clinical history to determine if Oestra<sup>®</sup> is right for you. If approved, your prescription is filled and shipped to your door.</>,
    },
    {
        id: 4,
        question: "How is Inner Balance’s approach to HRT different?",
        answer: "Most other HRTs focus on hormone levels individually. We take a more comprehensive approach, focusing on the ratios of estrogen, progesterone, and testosterone to bring them into balance—addressing the full spectrum of symptoms more effectively.",
    },
    {
        id: 5,
        question: "Do you offer a money-back guarantee?",
        answer: <>Yes. You have 6 full months to decide if Oestra<sup>®</sup> is right for you. If you&apos;re not seeing results, we’ll refund you—no questions asked.</>,
    },
];

export const faqPqpSafetyList = [
    {
        id: 1,
        question: "Is Oestra safe to use?",
        answer: "Yes. Estradiol and progesterone are FDA-approved for treatment because they have been tested for safety and efficacy. Extensive research—including 100+ high-quality trials and large-scale observational studies—demonstrates their safety and benefits. There are also 200+ studies on vaginal administration showing protection of the endometrial lining.",
    },
    {
        id: 2,
        question: "Is it safe for women to use a product with estrogen in it?",
        answer: "Yes, it is absolutely safe. In fact, increasing estrogen in perimenopause can protect against heart disease, increase bone strength, and support overall vitality—beyond improving brain fog, vaginal dryness, and hot flashes.",
    },
    {
        id: 3,
        question: "Is Oestra third-party tested?",
        answer: "Yes. All 503B compounding pharmacies (including ours) follow rigorous third-party testing and are regulated by the FDA, DEA, and state boards. Medications undergo potency, sterility, and quality checks before shipment.",
    },
    {
        id: 4,
        question: "Is this made in a safe pharmacy?",
        answer: <>Yes. Oestra<sup>®</sup> is compounded in a 503B FDA-regulated pharmacy that is also DEA-inspected and LegitScript certified. Each batch is tested for potency, purity, sterility, and consistency before shipping.</>,
    },
];

export const faqFacePqpBaseList = [
    {
        id: 1,
        question: "What is BodyMatched® Face Cream?",
        answer: <>BodyMatched<sup>®</sup> Face Cream is a physician-formulated, prescription-strength topical therapy designed to address the visible signs of aging in hormonally shifting skin. It combines bioidentical estriol, and a high-performance complex of clinically proven actives to support collagen, hydration & skin texture.</>,
    },
    {
        id: 2,
        question: "What is BodyMatched® Face Cream + Finasteride?",
        answer: "It’s a prescription-strength face cream designed to reduce facial hair, fade dark spots, smooth wrinkles, and boost collagen using bioidentical hormones and medical-grade ingredients.",
    },
    {
        id: 3,
        question: "Can BodyMatched® Face Cream be used with Oestra®?",
        answer: <>Yes. BodyMatched<sup>®</sup> Face Cream works locally on the skin, while Oestra<sup>®</sup> is a systemic hormone treatment taken through the body. Because they act in completely different ways and in different locations, they can be safely used together. Many women choose to combine them to target both the whole-body and visible skin aging at the surface.</>,
    },
    {
        id: 4,
        question: "What is the difference between the two creams?",
        answer: "Both creams are ideal for women of any age with signs of aging like wrinkles, dryness and uneven skin tone. Finasteride is proven to prevent and lessen unwanted facial hair.",
    },
    {
        id: 5,
        question: "Is this product safe for sensitive skin?",
        answer: "Yes, the dose and combination is well-tolerated by sensitive skin and can be started at every other day at first for a few weeks in those with extra sensitive skin.  Some mild irritation may occur at first—especially from tretinoin—but this usually fades with regular use.",
    },
    {
        id: 6,
        question: "What makes this cream different from other face products?",
        answer: "This formula combines hormone-informed care (like estriol and finasteride) with clinically proven dermatological actives (tretinoin), offering results far beyond over-the-counter skincare.",
    },
];

export const faqFacePqpIngredientsList = [
    {
        id: 1,
        question: "What does finasteride do in this face cream?",
        answer: "Topical finasteride blocks DHT, a hormone that causes unwanted facial hair, oily skin, and large pores. It helps reduce hair growth and smooth skin without major side effects.",
    },
    {
        id: 2,
        question: "Why is estriol included?",
        answer: "Estriol is a gentle, bioidentical estrogen that helps increase collagen, hydrate dry skin, and reduce fine lines. It’s especially helpful for peri- and postmenopausal women.",
    },
    {
        id: 3,
        question: "How does tretinoin help my skin?",
        answer: "Tretinoin boosts cell turnover, smooths wrinkles, treats acne, and improves skin texture. It’s one of the most studied and effective ingredients.",
    },
    {
        id: 4,
        question: "What is niacinamide good for?",
        answer: "Niacinamide (vitamin B3) helps fade dark spots, calm redness, shrink pores, and strengthen your skin barrier. It’s safe and effective for almost all skin types.",
    },
];

export const faqFacePqpUsageList = [
    {
        id: 1,
        question: "How often should I use it?",
        answer: "Start with once daily, preferably at night. If your skin is sensitive, you may want to begin every other day and increase slowly.",
    },
    {
        id: 2,
        question: "When will I see results?",
        answer: "Some women see improvements in hydration and texture within 2–4 weeks. Wrinkle reduction and hair thinning can take 8–12 weeks, with best results at 3–6 months.",
    },
    {
        id: 3,
        question: "Can I use it with other skincare products?",
        answer: "Yes, but avoid using other retinoids or exfoliants (like acids or scrubs) at the same time, especially when first starting. Always wear sunscreen during the day. ",
    },
];

export const faqFacePqpCommonList = [
    {
        id: 1,
        question: "Will it make my facial hair disappear completely?",
        answer: "No—it helps reduce the thickness, darkness, and growth rate of unwanted facial hair over time. Most women experience softer, finer hair.",
    },
    {
        id: 2,
        question: "Can this help with oily or acne-prone skin?",
        answer: "Yes! Both finasteride and niacinamide help reduce oil production, shrink pores, and calm inflammation.",
    },
    {
        id: 3,
        question: "Is it safe to use around the eyes?",
        answer: "Avoid applying directly on eyelids or too close to the lash line, but it’s safe for use around the orbital bone area unless otherwise directed by an Inner Balance clinician.",
    },
    {
        id: 4,
        question: "Are there any side effects?",
        answer: "You may experience slight dryness, redness, or peeling in the first few weeks. These effects are temporary and often resolve as your skin adjusts. Avoid the sun with use. ",
    },
];

const QuestionnaireComponent = () => {
    return (
        <span>
            Yes, this is a prescription-only formula and is prescribed to you by
            our licensed clinicians.{" "}
            <QuizTextLink className="cursor-pointer underline" href={QUIZ_ROUTES.ANTI_AGING_FACE_CREAM}>
                Our questionnaire{" "}
            </QuizTextLink>{" "}
            will guide you through a short evaluation to determine if it’s right
            for you.
        </span>
    );
};
export const faqFacePqpPrderingList = [
    {
        id: 1,
        question: "Do I need a prescription?",
        answer: <QuestionnaireComponent />,
    },
    {
        id: 2,
        question: "Is it vegan and fragrance-free?",
        answer: "Yes! Our cream is vegan, fragrance-free, paraben-free, and made without synthetic fillers.",
    },
    {
        id: 3,
        question: "How is the product made?",
        answer: "It’s compounded in a licensed U.S. pharmacy, third-party tested, and formulated by board-certified physician Dr. Sarah Daccarett.",
    },
    {
        id: 4,
        question: "Is this FDA-approved?",
        answer: "While some of the active ingredients are FDA-approved individually (like tretinoin), this specific compounded formula has not been reviewed by the FDA.",
    },
    {
        id: 5,
        question: "What if I have questions or side effects after starting the cream?",
        answer: "You'll have unlimited access to our clinical team for follow-up support. Whether you're experiencing dryness, irritation, or just want to check on your progress, our licensed providers are here to guide you.",
    },
];

export const faqFaceCreamForThankYouPageList = [
    {
        id: 1,
        question: "What is BodyMatched® Face Cream, and how does it work?",
        answer: <>BodyMatched<sup>®</sup> Anti-Aging Face Cream is a physician-formulated, prescription-strength topical therapy designed to address the visible signs of aging in hormonally shifting skin. It combines bioidentical estriol and a high-performance anti-aging complex of clinically proven actives to support collagen, hydration & skin texture.</>,
    },
    {
        id: 2,
        question: "What is BodyMatched® Face Cream with Finasteride?",
        answer: "This version of the cream is designed to reduce facial hair, fade dark spots, smooth wrinkles, and boost collagen. It includes topical finasteride in addition to estriol and tretinoin to target DHT-related skin changes.",
    },
    {
        id: 3,
        question: "What makes BodyMatched® Face Cream different from other anti-aging skincare?",
        answer: "This prescription-only formula combines hormone-informed care (like estriol and finasteride) with clinically proven dermatological actives (like tretinoin), delivering results beyond what you'll find in over-the-counter anti-aging products.",
    },
    {
        id: 4,
        question: "Why does the face cream contain estriol?",
        answer: "Estriol is a gentle, bioidentical estrogen that helps increase collagen, hydrate dry skin, and reduce fine lines. It's especially helpful for peri- and postmenopausal women.",
    },
    {
        id: 5,
        question: "What is the purpose of finasteride in the face cream?",
        answer: "Topical finasteride blocks DHT, a hormone that contributes to unwanted facial hair, oily skin, and enlarged pores. It helps smooth skin and reduce hair growth without major systemic side effects.",
    },
    {
        id: 6,
        question: "How does tretinoin in the face cream help my skin?",
        answer: "Tretinoin boosts cell turnover, smooths wrinkles, treats acne, and improves texture. It's one of the most studied and effective ingredients in prescription anti-aging skincare.",
    },
    {
        id: 7,
        question: "Will BodyMatched® Face Cream completely eliminate facial hair?",
        answer: "No — it helps reduce the thickness, darkness, and growth rate of unwanted facial hair over time. Most women experience finer, softer hair, not total removal.",
    },
    {
        id: 8,
        question: "Can BodyMatched® Face Cream help with acne or oily skin?",
        answer: "Yes. Finasteride and niacinamide (included in the formula) help reduce oil production, shrink pores, and calm inflammation — making the cream helpful for women with acne-prone or oily skin.",
    },
    {
        id: 9,
        question: "Are there any side effects with BodyMatched® Face Cream?",
        answer: "You may experience slight dryness, redness, or peeling in the first few weeks—especially from tretinoin. These effects are usually temporary and improve as your skin adjusts. Daily sunscreen is recommended.",
    },
    {
        id: 10,
        question: "Is BodyMatched® Face Cream safe for sensitive skin?",
        answer: "Yes. The dose and combination are well-tolerated by sensitive skin. If you're extra sensitive, start with every other day for a few weeks. Mild irritation may occur at first but typically resolves with consistent use.",
    },
    {
        id: 11,
        question: "Do I need a prescription for BodyMatched® Face Cream?",
        answer: "Yes. This cream is available by prescription only and is customized for you by Inner Balance clinicians. You'll complete a short evaluation to ensure it's appropriate for your skin and health history.",
    },
    {
        id: 12,
        question: "What if I have questions or side effects after starting the face cream?",
        answer: "You'll have unlimited access to our clinical care team for follow-up support. Whether you're experiencing irritation or just want to track progress, our licensed providers are here to help.",
    },
    {
        id: 13,
        question: "How often should I apply BodyMatched® Face Cream?",
        answer: "Start with once nightly. If your skin is sensitive, begin every other day and increase frequency gradually. Always follow with sunscreen in the morning.",
    },
    {
        id: 14,
        question: "When will I see results from the face cream?",
        answer: "You may notice increased hydration and smoother texture in 2–4 weeks. Wrinkle reduction and hair thinning typically take 8–12 weeks, with best results at 3–6 months of consistent use.",
    },
    {
        id: 15,
        question: "Can I use BodyMatched® Face Cream with other skincare products?",
        answer: "Yes — but avoid other retinoids or exfoliants (like scrubs or acids) while your skin adjusts. Keep your routine simple and always use SPF during the day.",
    },
    {
        id: 16,
        question: "Can I apply the face cream around my eyes?",
        answer: "Avoid direct application to eyelids or the lash line. It's safe to use around the orbital bone unless otherwise directed by your Inner Balance clinician.",
    },
];
